'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _availabilityStatus = require('@bibliocommons/availability-status');

var _availabilityStatus2 = _interopRequireDefault(_availabilityStatus);

var _holdCounts = require('@bibliocommons/hold-counts');

var _holdCounts2 = _interopRequireDefault(_holdCounts);

var _baseBcReactComponent = require('@bibliocommons/base-bc-react-component');

var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);

var _baseButtons = require('@bibliocommons/base-buttons');

var _utilsAnalytics = require('@bibliocommons/utils-analytics');

var _analyticsEventComposers = require('@bibliocommons/analytics-event-composers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var composeViewAvailabilityEvent = _analyticsEventComposers.availabilityEventComposer.composeViewAvailabilityEvent;


var propTypes = {
  availabilityStatus: _react.PropTypes.object.isRequired,
  supportsFastAvailability: _react.PropTypes.bool,
  availabilityDetailActions: _react.PropTypes.object.isRequired,
  reciprocalRank: _react.PropTypes.number
};

var DigitalBlock = function (_BcReactComponent) {
  _inherits(DigitalBlock, _BcReactComponent);

  function DigitalBlock() {
    _classCallCheck(this, DigitalBlock);

    var _this = _possibleConstructorReturn(this, (DigitalBlock.__proto__ || Object.getPrototypeOf(DigitalBlock)).call(this));

    _this.state = {
      isLoading: false
    };

    _this.bindAll('fetchLiveAvailability');
    return _this;
  }

  _createClass(DigitalBlock, [{
    key: 'componentWillUpdate',
    value: function componentWillUpdate(nextProps) {
      if (this.state.isLoading === true && nextProps.availabilityStatus.get('status') !== 'UNKNOWN') {
        this.setState({
          isLoading: false
        });
      }
    }
  }, {
    key: 'fetchLiveAvailability',
    value: function fetchLiveAvailability() {
      var _props = this.props,
          availabilityDetailActions = _props.availabilityDetailActions,
          availabilityStatus = _props.availabilityStatus,
          bib = _props.bib,
          reciprocalRank = _props.reciprocalRank;

      (0, _utilsAnalytics.sendAnalyticsEvents)(composeViewAvailabilityEvent({ status: availabilityStatus.get('status'), reciprocalRank: reciprocalRank }));
      this.setState({
        isLoading: true
      });
      availabilityDetailActions.getDigitalAvailability(bib.get('id'));
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          availabilityStatus = _props2.availabilityStatus,
          serviceAvailable = _props2.serviceAvailable,
          showAvailabilityStatus = _props2.showAvailabilityStatus,
          showHoldCount = _props2.showHoldCount,
          showCheckDigitalAvailabilityButton = _props2.showCheckDigitalAvailabilityButton;


      if (!serviceAvailable) {
        return _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'digital_service_unavailable' });
      }

      if (showCheckDigitalAvailabilityButton && availabilityStatus.get('status') === 'UNKNOWN') {
        return _react2.default.createElement(
          _baseButtons.TextButton,
          { className: 'check-availability-button', handleClick: this.fetchLiveAvailability, isLoading: this.state.isLoading },
          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'check_digital_availability' })
        );
      }

      return _react2.default.createElement(
        'div',
        { className: 'cp-digital-availability-block' },
        showAvailabilityStatus && _react2.default.createElement(_availabilityStatus2.default, {
          availabilityLocationType: availabilityStatus.get('availabilityLocationType'),
          rollUpStatus: availabilityStatus.get('status'),
          status: availabilityStatus.get('localisedStatus') }),
        _react2.default.createElement('br', null),
        showHoldCount && _react2.default.createElement(_holdCounts2.default, {
          heldCopies: availabilityStatus.get('heldCopies'),
          availableCopies: availabilityStatus.get('availableCopies'),
          totalCopies: availabilityStatus.get('totalCopies') })
      );
    }
  }]);

  return DigitalBlock;
}(_baseBcReactComponent2.default);

DigitalBlock.propTypes = propTypes;
DigitalBlock.displayName = 'DigitalBlock';
DigitalBlock.defaultProps = {
  showAvailabilityStatus: true,
  showCheckDigitalAvailabilityButton: true
};

exports.default = DigitalBlock;


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/availability-digital-block/lib/components/DigitalBlock.component.js
// module id = 1169
// module chunks = 0